import PropTypes from 'prop-types';
import React from 'react';
import connectToI18n from 'modules/i18n/connectToI18n';
import classnames from 'classnames';

export class CitiesSelect extends React.Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        cities: PropTypes.array.isRequired,
        citiesLoading: PropTypes.bool.isRequired,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        onChange: PropTypes.func.isRequired,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        trans: PropTypes.func.isRequired,
    };

    handleChange = event => {
        const select = event.target;
        this.props.onChange(this.props.name, select.value);
    };

    render() {
        const { className, disabled, name, value, cities, citiesLoading, trans } = this.props;

        let citiesList;
        if (!citiesLoading) {
            citiesList = cities.map(city => {
                return (
                    <option key={city.id} value={city.id}>
                        {city.name}
                    </option>
                );
            });
            if (cities.length > 1) {
                citiesList.unshift(
                    <option key="" value="">
                        {trans('user.city.choose')}
                    </option>
                );
            }
        }

        return (
            <span
                className={classnames('fa-input fa-input--block fa-input--select', className, {
                    'fa-input--disabled': disabled,
                })}
            >
                <select
                    disabled={disabled}
                    name={name}
                    id={name}
                    value={value || ''}
                    onChange={this.handleChange}
                >
                    {citiesList}
                </select>
            </span>
        );
    }
}

export default connectToI18n(CitiesSelect);
